import {
  WR_CLOSE,
  WR_OPEN,
  WR_SET_JOIN_ROOM_FAIL,
  WR_SET_JOIN_ROOM_REQUEST,
  WR_SET_JOIN_ROOM_RESET,
  WR_SET_JOIN_ROOM_SUCCESS,
} from "../constants/waitingRoomConstants";

export const wsmodul_status_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case WR_OPEN:
      return { loading: true };
    case WR_CLOSE:
      return { loading: false, success: true };
    default:
      return state;
  }
};

export const wsmodul_set_join_room_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case WR_SET_JOIN_ROOM_REQUEST:
      return { loading: true };
    case WR_SET_JOIN_ROOM_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case WR_SET_JOIN_ROOM_FAIL:
      return { loading: false, error: action.payload };
    case WR_SET_JOIN_ROOM_RESET:
      return {};
    default:
      return state;
  }
};
